(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Set initial height for the open group
  document.querySelectorAll('.lc-faq__group.is-open').forEach(function(group) {
    var items = group.querySelector('.lc-faq__group-items');
    items.style.maxHeight = items.scrollHeight + 'px';
  });

  // Group-level accordion
  document.querySelectorAll('.lc-faq__group-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.lc-faq__group');
      var items = group.querySelector('.lc-faq__group-items');
      var isOpen = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) {
        items.style.maxHeight = items.scrollHeight + 'px';
      } else {
        items.style.maxHeight = items.scrollHeight + 'px';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            items.style.maxHeight = '0';
          });
        });
      }
    });
  });

  // Question-level accordion
  document.querySelectorAll('.lc-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.lc-faq__item');
      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      // Recalculate parent group height after answer transition
      var group = item.closest('.lc-faq__group');
      if (group && group.classList.contains('is-open')) {
        setTimeout(function() {
          var items = group.querySelector('.lc-faq__group-items');
          items.style.maxHeight = items.scrollHeight + 'px';
        }, 360);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-nosotros"]) return;
  try {
    
(function() {
  document.querySelectorAll('.lc-nosotros__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var card = btn.closest('.lc-nosotros__card');
      var isOpen = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
